import styled from 'styled-components';
import modaLivre from 'assets/images/moda-livre-destaque.gif';

export const Container = styled.header`
  width: 100%;
  height: 100vh;
  display: flex;
  margin: 0 auto;

  @media screen and (max-width: 1220px) {
    flex-direction: column-reverse;
    height: auto;
  }
`;

export const Column = styled.div`
  width: 100%;
  height: 100vh;
  max-width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.left {
    padding: 96px;
  }

  &.right {
    background: url(${modaLivre}) no-repeat center center;
    background-size: cover;
  }

  @media screen and (max-width: 1220px) {
    max-width: 100%;
    height: auto;

    &.left {
      padding: 96px 40px;
    }
    &.right {
      background: none;
    }
  }

  @media screen and (max-width: 500px) {
    &.left {
      padding: 56px 40px;
    }
  }
`;

export const ModaLivreGif = styled.img.attrs({ src: modaLivre })`
  display: none;
  width: 100%;

  @media screen and (max-width: 1220px) {
    display: block;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 580px;
`;

export const Headline = styled.h1`
  font-size: 52px;
  text-transform: uppercase;
  color: #111111;
  margin-bottom: 32px;

  @media screen and (max-width: 1520px) {
    font-size: 44px;
  }
  @media screen and (max-width: 1366px) {
    font-size: 40px;
  }
  @media screen and (max-width: 500px) {
    font-size: 30px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 32px;
  width: 500px;
`;

export const Text = styled.article`
  font-size: 22px;
  line-height: 30px;
  color: #111111;
  max-width: 400px;

  p {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }

    span {
      text-transform: uppercase;
    }
  }

  @media screen and (max-width: 500px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
